import React, { memo } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import { useSelector } from "react-redux"
import Header from "@/components/template/protectTemplate/Header"
import Content from "@/components/template/protectTemplate/Content"
import Footer from "@/components/template/protectTemplate/Footer"
import RequestSnackbar from "@/components/common/RequestSnackbar"
import { Navigate } from "react-router-dom"

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    pageContainer: {
        position: "relative",
        minHeight: "100vh",
        height: "100%",
    },
    headerWrapper: {
        flex: "0 1 auto",
        zIndex: 3,
    },
    contentWrapper: {
        flex: "1 1 auto",
        display: "flex",
        flexDirection: "column",
    },
    footerWrapper: {
        flex: "0 1 146px",
        [theme.breakpoints.up("lg")]: {
            flex: "0 1 80px",
        },
    },
}))

const Admin = memo(() => {
    const classes = useStyles()
    const userData = useSelector((state) => state.userReducer)
    const accessToken = localStorage.getItem("accessToken")

    if (accessToken === null) {
        return <Navigate replace to="/login" />
    }

    if (userData && userData.user !== null && Object.keys(userData.user).length === 0 && userData.user.constructor === Object) {
        // redirect to login
        return (
            <RequestSnackbar
                status={false}
                message="Token has been expired. Please login again"
                snackbarOpen
                redirectStatus
                redirectPath="/login"
            />
        )
    }

    return (
        <>
            <Grid container direction="column" className={classes.pageContainer}>
                <Grid item xs={12} className={classes.headerWrapper}>
                    <Header />
                </Grid>
                <Grid item xs={12} className={classes.contentWrapper}>
                    <Content />
                </Grid>
                <Grid item xs={12} className={classes.footerWrapper}>
                    <Footer />
                </Grid>
            </Grid>
        </>
    )
})

export default Admin
